import styled from 'styled-components';

export const BlogContainer = styled.div`
	color: white;
	width: 100vw;
	height: 100vh;
	max-height: 100vh;
	overflow-x: hidden;
	overflow-y: auto;

	.home-scroll {
		width: 100%;
		display: flex;
		flex-direction: column;
        align-items: center;
		padding-top: 2rem;

        .centered-nav {
            margin: 1.5rem;
            font-size: 1.2em;
            font-weight: bold;
        }

		.blog-banner {
			width: 100%;
			height: 500px;
            max-height: ${window.screen.width <= 1000 
                ? '30vh'
                // : window.screen.width >= 500 && window.screen.width <= 1025
                // ? 'clamp(2rem, 2vw, 3.7rem)'
                : '60vh'
            };
			overflow: hidden;

			img {
                // width: 1200px;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.content-wrapper {
			margin-top: 20px;
			padding: 5px;
			// background-color: red;
			width: 1100px;
			max-width: 98%;

			h1 {
				font-size: ${window.screen.width <= 1000 ? '1.4rem' : '3.2rem'};
			}

			p {
				font-size: ${window.screen.width <= 1000 ? '1rem' : '1.6rem'};
				line-height: ${window.screen.width <= 1000 ? '1.2rem' : '2.2rem'};
			}

			.info {
				line-height: 1.5rem;
			}
		}
	}
`;
